var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGharGhantiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325.999,
    cy: 416,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.999,
    cy: 316,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.999,
    cy: 316,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.999,
    cy: 316,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.999,
    cy: 316,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 316,
    r: 10,
    fill: "current",
    className: "color000 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476 25.999H35.998c-5.522 0-10 4.478-10 10v110c0 5.522 4.478 10 10 10h20v320.002c0 5.522 4.478 10 10 10H446c5.522 0 10-4.478 10-10V155.999h20c5.522 0 10-4.478 10-10v-110c0-5.523-4.478-10-10-10zm-10 20v50h-30v-20c0-5.522-4.478-10-10-10H85.998c-5.522 0-10 4.478-10 10v20h-30v-50H466zm-50 50H95.998v-10H416v10zM75.998 206h20v260.001h-20V206zM396 206v30H224.28c-4.131-11.641-15.244-20-28.281-20-13.038 0-24.151 8.359-28.282 20h-51.719v-30H396zm0 50v10H225.999v-10H396zm-280.002 30h50v10c0 1.973.586 3.9 1.68 5.547l18.32 27.48V356c0 5.521 4.478 10 10 10H351c2.758 0 5 2.241 5 5 0 2.754-2.242 5-5 5H160.999c-13.784 0-25 11.216-25 25s11.216 25 25 25h135c5.522 0 10-4.477 10-10 0-5.521-4.478-10-10-10h-135a5.01 5.01 0 0 1-5-5c0-2.759 2.246-5 5-5H351c13.783 0 25-11.216 25-25s-11.217-25-25-25H205.999v-16.973l18.32-27.48a10.02 10.02 0 0 0 1.68-5.547v-10H396v150H115.998V286zm90.001 6.973-10 15-10-15V246c0-5.513 4.482-10 10-10s10 4.487 10 10v46.973zm-40-26.973h-50v-10h50v10zm-50.001 190.001H396v10H115.998v-10zm320.002 10h-20V206h20v260.001zm0-280.002H75.998v-30H436v30zm-390.002-50v-20H466v20H45.998z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGharGhantiIcon);
export default __webpack_public_path__ + "static/media/ghar-ghanti-icon.a8549bd158df91fea932339a9d5f233a.svg";
export { ForwardRef as ReactComponent };